<template>
  <div>
    <component :is="component" v-bind="comData" v-if="component" @AfterRendering="AfterRendering" @childevent="childevent" @update="update" ref="dynam">
      <template :slot="key" v-for="(val,key) in $slots">
        <slot :name="key"></slot>
      </template>
    </component>
  </div>
</template>

<script>
  export default {
    name: "DynamicLink",
    props:{
      /**
       *宋建国：2019/12/26 12:48
       *描述：组件，路由路径
       *版本：1.0
       */
      type: {
        type: String,
        default: ''
      },
      /**
       *宋建国：2020/2/26 10:14
       *描述：组件，容器组件、展示组件、功能组件的组件名称
       *版本：1.0
       */
      componentname: {
        type : String,
        default: ''
      },
      /**
       *宋建国：2019/12/26 12:48
       *描述：组件数据
       *版本：1.0
       */
      comData: {}
    },

    data(){
      return {
        /**
         *宋建国：2020/3/6 13:01
         *描述：当前动态加载的组件
         *版本：1.0
         */
        selfComp: null,
        compName: '',
        component: {template:"<div>加载中...</div>"},
        eventname:''
      }
    },
    watch:{
      compName(newCompName,oldCompName){
        if(!this.componentname){
          console.error("DynamicLink动态加载组件，加载组件名称不能为空");
          return null;
        }
        /**
         *宋建国：2020/2/26 10:17
         *描述：加载组件功能，加载顺序---
         * this.type: 组件路由
         * newCompName: 组件名称
         *版本：1.0
         */
        this.$api.component.IngleComponent(this,this.type,newCompName)
          .then((res)=>{
            this.component = res;
          }).catch((error)=>{
          this.$message.error(error);
        })
      }
    },
    methods:{
      /**
       *宋建国：2020/3/6 13:03
       *描述：返回组件实例
       *版本：1.0
       */
      RefComp(){
        return this.selfComp;
      },
      /**
       *宋建国：2020/1/5 1:45
       *描述：基础组件返回渲染完成事件
       *版本：1.0
       */
      AfterRendering(comp){
        this.selfComp = comp;
        this.$emit('AfterRendering', this.componentname,comp);
      },
      /* 组件中有需要父组件使用的数据用$emit */
      childevent(value){
        this.$emit('childevents',value)
      },
      update(data,res){
        this.$emit('update',data,res)
      }
    },
    mounted(){
      this.compName = this.componentname;
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/vueformmaking/DynamicLink.vue